export const g = {
  globalProperties: null,
};

export function initGlobal(app) {
  g.globalProperties = app.config.globalProperties;
}
